import styled from '@emotion/styled';
import vars from '@variables';
import { defineResponsiveGridColumns } from '@utils/utils';
import { H2Atom, PAtom } from '@atoms/text-atoms/text-atoms';
import { sectionTitleBorder } from '../../mixins';
import { InternalLinkAtom } from '@atoms/link-atoms/link-atoms';

export const TileBlockContainer = styled.div<{ colour?: string }>`
  margin-top: ${vars.spacingXxl};
  margin-bottom: ${vars.spacingXxl};
`;

export const GridStructure = styled.div`
  display: grid;
  column-gap: ${vars.mobileColumnPercentageGap};
  grid-template-columns: 3fr 1fr;
  margin-bottom: ${vars.spacingM};
`;

export const TitleDescriptionWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${vars.spacingM};
`;

export const TileBlockTitle = styled(H2Atom)<{ colour?: string }>`
  grid-column: 1 / -1;
  ${({ colour }) => sectionTitleBorder(colour)}
  &::first-letter {
    text-transform: uppercase;
  }
`;

export const TileBlockDescription = styled(PAtom)`
  padding: 0;
  margin: 0;
`;

export const TileBlockCTA = styled(InternalLinkAtom)`
  font-weight: ${vars.fontWeightBold};
  ${vars.fontSize2}
  text-decoration: none;
  color: ${vars.coreDarkGrey};
  text-align: right;
  margin-left: auto;
  margin-top: auto;
`;

interface TilesGridProps {
  tilesCount: number;
}
export const TilesGrid = styled.div<TilesGridProps>`
  display: grid;
  grid-template-columns: ${({ tilesCount }) =>
    defineResponsiveGridColumns(tilesCount)};
  gap: 1.8rem;

  // on mobile, tiles are stacked on top of each other
  @media screen and (max-width: calc(${vars.breakPointTablet} - 1px)) {
    grid-template-columns: 1fr;
  }
`;
